import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { FC, useEffect, useState, useRef } from "react";
import { Button } from "components/shared";
import { ReactComponent as InfoIcon } from "images/infoIcon.svg";
import StepInfo from "pages/StepPages/components";
import Search from "components-new/Search";
import { Table } from "./Table/Table";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { useParams } from "react-router-dom";
import { getSelectedOrganization } from "toolkit/organizations/organizations.thunks";
import { ChangeSearchValue, resetStep_2_2 } from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.slice";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import { AddingAndEditionObject } from "./AddingAndEditionObject/AddingAndEditionObject";
import styles from "./ObjectsRegister.module.sass";

export const ObjectsRegister: FC = () => {
	const [modalWindow, setModalWindow] = useState<boolean>(false);
	const selectedOrganization = useAppSelector((state) => state.organizations.selectedOrganization);
	const [isHelper, setIsHelper] = useState<boolean>(true);
	const { searchValue } = useAppSelector((state) => state.objectsRegister);
	const { organizationId } = useParams();
	const dispatch = useAppDispatch();
	const helperRef = useRef(null);
	useOutsideAlerter(helperRef.current, () => setIsHelper(false));

	useEffect(() => {
		if (!organizationId) return;
		if (+organizationId !== selectedOrganization?.id) dispatch(getSelectedOrganization(+organizationId));
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		return () => {
			dispatch(resetStep_2_2());
		};
		//eslint-disable-next-line
	}, []);

	const openHelper = () => {
		if (isHelper) return;
		setTimeout(() => {
			setIsHelper((prev) => !prev);
		}, 1);
	};

	return (
		<>
			{modalWindow && (
				<ModalWindow close={() => setModalWindow(false)} width={"big"}>
					<AddingAndEditionObject type="add" object={null} close={() => setModalWindow(false)} />
				</ModalWindow>
			)}
			<main className={styles.content}>
				<section className={styles.categorization}>
					<div className={styles.header}>
						<StepInfo
							stepTitle={"2.2 Создание реестра объектов"}
							info="Реестр объектов организации"
							companyName={selectedOrganization?.fullName}
						/>
						<div className={styles["header-item"]}>
							<div className={styles["info-icon-wrp"]}>
								<div onClick={openHelper}>
									<InfoIcon />
								</div>
								<div ref={helperRef}>
									{isHelper && (
										<div className={styles["helper"]}>
											Нажмите на наименование объекта для заполнения дополнительных сведений об объекте
										</div>
									)}
								</div>
							</div>
							<Search
								className={styles.search}
								searchValue={searchValue}
								handleSearch={(e) => dispatch(ChangeSearchValue(e.target.value))}
							/>
							<Button onClick={() => setModalWindow(true)} className={styles.button}>
								Добавить объект
							</Button>
							{/* <Button className={styles.button}>Импорт списка объектов</Button> */}
							{/* <Menu /> */}
						</div>
					</div>
					<Table />
				</section>
			</main>
		</>
	);
};
